import {ChangeDetectorRef, Component, ViewChild} from '@angular/core';

import {tap} from 'rxjs/operators';

import {ToastrService} from 'ngx-toastr';
import {Destroyable} from '../../../destroyable.component';
import {SdcLogsListComponent} from '../sdc-logs-list/sdc-logs-list.component';
import {PersonPayrollLogsListComponent} from '../sdc-person-logs-list/person-payroll-logs-list.component';
import {SdcEventTypes} from '../sdconnect.model';
import {SdconnectService} from '../sdconnect.service';

@Component({
  selector: 'gp-payroll-input-admin',
  templateUrl: './payroll-input-admin.component.html',
  styleUrls: ['./payroll-input-admin.component.scss']
})
export class PayrollInputAdminComponent extends Destroyable {

  protected readonly SdcEventTypes = SdcEventTypes;

  @ViewChild(SdcLogsListComponent)
  private sdcLogListComponent: SdcLogsListComponent;

  @ViewChild(PersonPayrollLogsListComponent)
  private payrollLogsListComponent: PersonPayrollLogsListComponent;

  public displayLatestPayrollLogsOnly = true;

  public contractId: string = null;

  public activeLogTab: 'sdc' | 'payroll' = 'sdc';

  constructor(
    private sdconnectService: SdconnectService,
    private toastrService: ToastrService,
    private cd: ChangeDetectorRef) {
    super();
  }

  public load(contractId: string) {
    this.contractId = contractId;
    this.cd.detectChanges();
  }

  public reloadActiveLogs() {
    if (this.activeLogTab === 'sdc') {
      this.reloadSdcLogs();
    } else {
      this.reloadPayrollLogs();
    }
  }

  public forceSyncPayrollToSDC3() {
    this.sdconnectService.forceSyncPayrollToSDC3(this.contractId).pipe(
      tap(() => {
        this.toastrService.success(`Force sync payroll triggered, reload employee file in a few seconds.`);
      })
    ).subscribe();
  }

  public reloadSdcLogs() {
    this.sdcLogListComponent.reload();
    this.sdconnectService.sdcLogsRefreshed$.next();
  }

  public reloadPayrollLogs() {
    this.payrollLogsListComponent.reload();
  }

  public toggleDisplayLatestPayrollLogsOnly(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.displayLatestPayrollLogsOnly = inputElement.checked;
  }
}
